module.exports = __webpack_public_path__ + "static/media/Img_20.c907718b.JPG";